export const API_ENDPOINTS = {
  ADMIN: {
    SCREEN_MASTER: "/AdminModule/screen-masters",
    COMPONENT_MASTER: "/AdminModule/component-masters",
    INPUT_CATEGORY_MASTER: "/AdminModule/input-category-masters",
    KPI_MASTER: "/AdminModule/kpi-masters",
    LOGIN: "/AdminModule/login",
    CREATE_CONFIGURATION: "/AdminModule/configuration-detail",
    GET_CONFIGURATION_DETAILS: "/AdminModule/configuration-details-filter",
  },

  AUTH: {
    ADMIN_LOGIN: "/AdminModule/login",
  },

  HOME: {
    GET_CONFIGURATION_DETAILS: "/Home/pagewise-config",
    FINANCIAL_KPI_ONE: "/Home/financial-kpi-one",
    FINANCIAL_KPI_TWO: "/Home/financial-kpi-two",
    FINANCIAL_KPI_THREE: "/Home/financial-kpi-three",
    FINANCIAL_KPI_FOUR: "/Home/financial-kpi-four",
    FINANCIAL_KPI_FIVE: "/Home/financial-kpi-five",
    FINANCIAL_KPI_SIX: "/Home/financial-kpi-six",
    FINANCIAL_KPI_SEVEN: "/Home/financial-kpi-seven",
    TECHNICAL_KPI_ONE: "/Home/technical-kpi-first",
    TECHNICAL_KPI_TWO: "/Home/technical-kpi-second",
    TECHNICAL_KPI_THREE: "/Home/technical-kpi-third",
    CAPACITY_KPI_ONE: "/Home/capacity-kpi-first",
    CAPACITY_KPI_TWO: "/Home/capacity-kpi-second",
    CAPACITY_KPI_THREE: "/Home/capacity-kpi-third",
    COUNTRY_EXPLORER: "/Home/country-explorer",
  },

  COUNTRY: {
    GET_COUNTRY_LIST: "/Country/country-list",
    GET_HERO_TABLE_DATA: "/Country/country-convention-agreement",
    GET_KEY_POLICY_DATA: "/Country/country-key-climate-policy-doc",
    GET_COUNTRY_CONFIG_DETAILS: "/Country/country-config-details",
  },

  CLIMATE_ASSISTANT: {
    ASSISTANT_RESPONSE: "/Chatbot/chatbot-config-data",
    GET_PROMPTS: "/Chatbot/prompts-by-query",
  },

  GLOBAL_SEARCH: {
    GET_SEARCH_RESULTS: "Home/global-search",
  },

  FINANCIAL: {
    GET_KPI_LIST: "/FinancialDataset/all-kpi-list",
    FINANCIAL_KPI_ONE_FILTER: "/FinancialDataset/ftc-financial-kpi-one-filter",
    FINANCIAL_KPI_ONE_GRAPH: "/FinancialDataset/ftc-financial-kpi-one-graph",
    FINANCIAL_KPI_ONE_TABLE: "/FinancialDataset/ftc-financial-kpi-one-table",
    FINANCIAL_KPI_ONE_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-one-factoids",
    FINANCIAL_KPI_ONE_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-one-table-filters",
    FINANCIAL_KPI_ONE_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-one-graph-analysis",
    FINANCIAL_KPI_TWO_FILTER: "/FinancialDataset/ftc-financial-kpi-two-filter",
    FINANCIAL_KPI_TWO_GRAPH: "/FinancialDataset/ftc-financial-kpi-two-graph",
    FINANCIAL_KPI_TWO_TABLE: "/FinancialDataset/ftc-financial-kpi-two-table",
    FINANCIAL_KPI_TWO_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-two-factoids",
    FINANCIAL_KPI_TWO_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-two-table-filters",
    FINANCIAL_KPI_TWO_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-two-graph-analysis",
    FINANCIAL_KPI_THREE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-three-filter",
    FINANCIAL_KPI_THREE_GRAPH:
      "/FinancialDataset/ftc-financial-kpi-three-graph",
    FINANCIAL_KPI_THREE_TABLE:
      "/FinancialDataset/ftc-financial-kpi-three-table",
    FINANCIAL_KPI_THREE_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-three-factoids",
    FINANCIAL_KPI_THREE_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-three-table-filters",
    FINANCIAL_KPI_THREE_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-three-graph-analysis",
    FINANCIAL_KPI_FOUR_FILTER:
      "/FinancialDataset/ftc-financial-kpi-four-filter",
    FINANCIAL_KPI_FOUR_GRAPH: "/FinancialDataset/ftc-financial-kpi-four-graph",
    FINANCIAL_KPI_FOUR_TABLE: "/FinancialDataset/ftc-financial-kpi-four-table",
    FINANCIAL_KPI_FOUR_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-four-factoids",
    FINANCIAL_KPI_FOUR_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-four-table-filters",
    FINANCIAL_KPI_FOUR_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-four-graph-analysis",
    FINANCIAL_KPI_FIVE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-five-filter",
    FINANCIAL_KPI_FIVE_GRAPH: "/FinancialDataset/ftc-financial-kpi-five-graph",
    FINANCIAL_KPI_FIVE_TABLE: "/FinancialDataset/ftc-financial-kpi-five-table",
    FINANCIAL_KPI_FIVE_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-five-factoids",
    FINANCIAL_KPI_FIVE_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-five-table-filters",
    FINANCIAL_KPI_FIVE_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-five-graph-analysis",
    FINANCIAL_KPI_SIX_FILTER: "/FinancialDataset/ftc-financial-kpi-six-filter",
    FINANCIAL_KPI_SIX_GRAPH: "/FinancialDataset/ftc-financial-kpi-six-graph",
    FINANCIAL_KPI_SIX_TABLE: "/FinancialDataset/ftc-financial-kpi-six-table",
    FINANCIAL_KPI_SIX_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-six-factoids",
    FINANCIAL_KPI_SIX_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-six-table-filters",
    FINANCIAL_KPI_SIX_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-six-graph-analysis",
    FINANCIAL_KPI_SEVEN_FILTER:
      "/FinancialDataset/ftc-financial-kpi-seven-filter",
    FINANCIAL_KPI_SEVEN_GRAPH:
      "/FinancialDataset/ftc-financial-kpi-seven-graph",
    FINANCIAL_KPI_SEVEN_TABLE:
      "/FinancialDataset/ftc-financial-kpi-seven-table",
    FINANCIAL_KPI_SEVEN_FACTOID:
      "/FinancialDataset/ftc-financial-kpi-seven-factoids",
    FINANCIAL_KPI_SEVEN_TABLE_FILTER:
      "/FinancialDataset/ftc-financial-kpi-seven-table-filters",
    FINANCIAL_KPI_SEVEN_ANALYSIS:
      "/FinancialDataset/ftc-financial-kpi-seven-graph-analysis",
  },

  TECHNOLOGY: {
    TECHNOLOGY_KPI_ONE_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-one-filter",
    TECHNOLOGY_KPI_ONE_GRAPH: "/TechnologyDataset/ftc-technology-kpi-one-graph",
    TECHNOLOGY_KPI_ONE_TABLE: "/TechnologyDataset/ftc-technology-kpi-one-table",
    TECHNOLOGY_KPI_ONE_FACTOID:
      "/TechnologyDataset/ftc-technology-kpi-one-factoids",
    TECHNOLOGY_KPI_ONE_TABLE_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-one-table-filters",
    TECHNOLOGY_KPI_ONE_ANALYSIS:
      "/TechnologyDataset/ftc-technology-kpi-one-graph-analysis",

    TECHNOLOGY_KPI_SECOND_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-two-filter",
    TECHNOLOGY_KPI_SECOND_GRAPH:
      "/TechnologyDataset/ftc-technology-kpi-two-graph",
    TECHNOLOGY_KPI_SECOND_TABLE:
      "/TechnologyDataset/ftc-technology-kpi-two-table",
    TECHNOLOGY_KPI_SECOND_FACTOID:
      "/TechnologyDataset/ftc-technology-kpi-two-factoids",
    TECHNOLOGY_KPI_SECOND_TABLE_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-two-table-filters",
    TECHNOLOGY_KPI_SECOND_ANALYSIS:
      "/TechnologyDataset/ftc-technology-kpi-two-graph-analysis",

    TECHNOLOGY_KPI_THREE_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-third-filter",
    TECHNOLOGY_KPI_THREE_GRAPH:
      "/TechnologyDataset/ftc-technology-kpi-third-graph",
    TECHNOLOGY_KPI_THREE_TABLE:
      "/TechnologyDataset/ftc-technology-kpi-third-table",
    TECHNOLOGY_KPI_THREE_FACTOID:
      "/TechnologyDataset/ftc-technology-kpi-third-factoids",
    TECHNOLOGY_KPI_THREE_TABLE_FILTER:
      "/TechnologyDataset/ftc-technology-kpi-third-table-filters",
    TECHNOLOGY_KPI_THREE_ANALYSIS:
      "/TechnologyDataset/ftc-technology-kpi-third-graph-analysis",
  },

  CAPACITY: {
    CAPACITY_KPI_ONE_FILTER: "/CapacityDataset/ftc-capacity-kpi-one-filter",
    CAPACITY_KPI_ONE_GRAPH: "/CapacityDataset/ftc-capacity-kpi-one-graph",
    CAPACITY_KPI_ONE_TABLE: "/CapacityDataset/ftc-capacity-kpi-one-table",
    CAPACITY_KPI_ONE_FACTOID: "/CapacityDataset/ftc-capacity-kpi-one-factoids",
    CAPACITY_KPI_ONE_TABLE_FILTER:
      "/CapacityDataset/ftc-capacity-kpi-one-table-filters",
    CAPACITY_KPI_ONE_ANALYSIS:
      "/CapacityDataset/ftc-capacity-kpi-one-graph-analysis",

    CAPACITY_KPI_SECOND_FILTER:
      "/CapacityDataset/ftc-capacity-kpi-second-filter",
    CAPACITY_KPI_SECOND_GRAPH: "/CapacityDataset/ftc-capacity-kpi-second-graph",
    CAPACITY_KPI_SECOND_TABLE: "/CapacityDataset/ftc-capacity-kpi-second-table",
    CAPACITY_KPI_SECOND_FACTOID:
      "/CapacityDataset/ftc-capacity-kpi-second-factoids",
    CAPACITY_KPI_SECOND_TABLE_FILTER:
      "/CapacityDataset/ftc-capacity-kpi-second-table-filters",
    CAPACITY_KPI_SECOND_ANALYSIS:
      "/CapacityDataset/ftc-capacity-kpi-second-graph-analysis",

    CAPACITY_KPI_THREE_FILTER: "/CapacityDataset/ftc-capacity-kpi-three-filter",
    CAPACITY_KPI_THREE_GRAPH: "/CapacityDataset/ftc-capacity-kpi-three-graph",
    CAPACITY_KPI_THREE_TABLE: "/CapacityDataset/ftc-capacity-kpi-three-table",
    CAPACITY_KPI_THREE_FACTOID:
      "/CapacityDataset/ftc-capacity-kpi-three-factoids",
    CAPACITY_KPI_THREE_TABLE_FILTER:
      "/CapacityDataset/ftc-capacity-kpi-three-table-filters",
    CAPACITY_KPI_THREE_ANALYSIS:
      "/CapacityDataset/ftc-capacity-kpi-three-graph-analysis",
  },
};
